export default __webpack_public_path__ + "static/media/CL.71b8727f.svg";